export const Energy = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="31" viewBox="0 0 14 31">
    <g fill="none" fillRule="evenodd">
      <g fill="#2396FD" fillRule="nonzero">
        <path
          d="M125 440.825L120.03 440.825 120.03 428 113 446.175 117.97 446.175 117.97 459z"
          transform="translate(-112.000000, -428.000000) translate(119.000000, 443.500000) rotate(7.000000) translate(-119.000000, -443.500000)"
        />
      </g>
    </g>
  </svg>
);
